/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Equipment_AvailableInputs */

const en_field_equipment_available = /** @type {(inputs: Field_Equipment_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipment Summary`)
};

const es_field_equipment_available = /** @type {(inputs: Field_Equipment_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumen de equipamiento`)
};

const fr_field_equipment_available = /** @type {(inputs: Field_Equipment_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Résumé des équipements`)
};

const de_field_equipment_available = /** @type {(inputs: Field_Equipment_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zusammenfassung der Ausstattung`)
};

const ja_field_equipment_available = /** @type {(inputs: Field_Equipment_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用可能な機材・備品`)
};

const zh_field_equipment_available = /** @type {(inputs: Field_Equipment_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`设备概览`)
};

const ar_field_equipment_available = /** @type {(inputs: Field_Equipment_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ملخص المعدات`)
};

const id_field_equipment_available = /** @type {(inputs: Field_Equipment_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ringkasan Peralatan`)
};

const it_field_equipment_available = /** @type {(inputs: Field_Equipment_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attrezzatura Disponibile`)
};

const ru_field_equipment_available = /** @type {(inputs: Field_Equipment_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Доступное оборудование`)
};

const pt_field_equipment_available = /** @type {(inputs: Field_Equipment_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resumo de Equipamentos`)
};

const ko_field_equipment_available = /** @type {(inputs: Field_Equipment_AvailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이용 가능 장비 요약`)
};

/**
* | output |
* | --- |
* | "Equipment Summary" |
*
* @param {Field_Equipment_AvailableInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const field_equipment_available = /** @type {((inputs?: Field_Equipment_AvailableInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Equipment_AvailableInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_field_equipment_available(inputs)
	if (locale === "es") return es_field_equipment_available(inputs)
	if (locale === "fr") return fr_field_equipment_available(inputs)
	if (locale === "de") return de_field_equipment_available(inputs)
	if (locale === "ja") return ja_field_equipment_available(inputs)
	if (locale === "zh") return zh_field_equipment_available(inputs)
	if (locale === "ar") return ar_field_equipment_available(inputs)
	if (locale === "id") return id_field_equipment_available(inputs)
	if (locale === "it") return it_field_equipment_available(inputs)
	if (locale === "ru") return ru_field_equipment_available(inputs)
	if (locale === "pt") return pt_field_equipment_available(inputs)
	return ko_field_equipment_available(inputs)
});